import React, { useCallback, useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import { Modal } from "react-bootstrap";
import swal from "sweetalert";

const CouponCode = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [postModal, setPostModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [addFormData, setAddFormData] = useState({
    OfferCode: "",
    OfferName: "",
    DiscountAmount: "",
    MinRechargeAmount: "",
    BonusPercentage: "",
    CreatedByUser: "",
  });
  const [packages, setPackages] = useState([]);
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [packagesLoaded, setPackagesLoaded] = useState(false);

  const fetchData = useCallback(async (signal) => {
    setLoading(true);
    setError(null);
    try {
      const response = await AddUpdate("UserOffers/GetData_OfferMaster", {});

      if (signal?.aborted) return;
      const parsed = JSON.parse(response?.data?.data || "{}");
      const rows = parsed?.Table || [];
      setData(rows);
    } catch (err) {
      if (signal?.aborted) return;
      console.error("Error fetching offers:", err);
      setError("Failed to load offers");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = { aborted: false };
    fetchData(controller);
    return () => {
      controller.aborted = true;
    };
  }, [fetchData]);

  const columns = useMemo(
    () => [
      { name: "OfferCode", selector: (row) => row.OfferCode, sortable: true },
      { name: "OfferName", selector: (row) => row.OfferName, sortable: true },
      {
        name: "BonusAmount",
        selector: (row) => row.BonusAmount,
        sortable: true,
      },
      {
        name: "MinRechargeAmount",
        selector: (row) => row.MinRechargeAmount,
        sortable: true,
      },
        {
        name: "DiscountType",
        selector: (row) => row.DiscountType,
        sortable: true,
      },
        {
        name: "TotalAmount",
        selector: (row) => row.TotalAmount,
        sortable: true,
      },
    ],
    [],
  );

  const resetForm = useCallback(() => {
    setAddFormData({
      OfferCode: "",
      OfferName: "",
      DiscountAmount: "",
      MinRechargeAmount: "",
      BonusPercentage: "",
      CreatedByUser: "",
    });
    setPackages([]);
    setSelectedPackages([]);
    setPackagesLoaded(false);
  }, []);

  const handleAddFormSubmit = async (e) => {
    e.preventDefault();
    if (!addFormData.OfferCode?.toString().trim()) {
      swal("Validation", "Offer Code is required", "warning");
      return;
    }
    setSaving(true);
    try {
      console.log(
        "Submitting offer. MinRechargeAmount (input):",
        addFormData.MinRechargeAmount,
      );
      console.log("Submitting offer. selectedPackages:", selectedPackages);
      console.log("Submitting offer. packages count:", packages?.length);

      let minRechargeValue = addFormData.MinRechargeAmount;
      if (selectedPackages && selectedPackages.length > 0) {
        const getAmountForSid = (sid) => {
          if (sid === null || sid === undefined) return null;
          if (typeof sid === "object") {
            return (
              sid.PackageAmt ??
              sid.Amount ??
              sid.PackageAmount ??
              sid.Price ??
              null
            );
          }
          const sidStr = String(sid);
          const p = packages.find((pkg) => {
            return (
              String(pkg.WalletPackageID ?? "") === sidStr ||
              String(pkg.PackageID ?? "") === sidStr ||
              String(pkg.Id ?? "") === sidStr ||
              String(pkg.PackageId ?? "") === sidStr ||
              String(pkg.ID ?? "") === sidStr
            );
          });
          if (!p) return null;
          return p.PackageAmt ?? p.Amount ?? p.PackageAmount ?? p.Price ?? null;
        };

        const amounts = selectedPackages
          .map((sid) => getAmountForSid(sid))
          .filter((v) => v !== "" && v !== undefined && v !== null)
          .map((v) => String(v).replace(/[^0-9.\-]/g, ""));

        if (amounts.length > 0) {
          minRechargeValue = amounts.join(",");
        } else {
          const numericIds = selectedPackages
            .map((s) => String(s))
            .filter((s) => /^\d+(?:\.\d+)?$/.test(s));
          if (numericIds.length > 0) minRechargeValue = numericIds.join(",");
        }
      }

      const payload = {
        OfferCode: addFormData.OfferCode,
        OfferName: addFormData.OfferName,
        DiscountAmount: addFormData.DiscountAmount,
        MinRechargeAmount: minRechargeValue,
        DiscountType: addFormData.BonusPercentage || "",
        CreatedByUser: 1,
      };
      console.log("Payload:", payload);
      const response = await AddUpdate(
        "UserOffers/Insert_OfferMaster",
        payload,
      );
      if (response) {
        swal("Success", "Offer added", "success");
        setPostModal(false);
        resetForm();
        fetchData();
      }
    } catch (err) {
      console.error("Error adding offer:", err);
      swal("Error", "Could not add offer", "error");
    } finally {
      setSaving(false);
    }
  };

  const loadPackages = async (selectAll = true) => {
    try {
      const res = await AddUpdate("WalletPackage/GetData_WalletPackage", {
        IsActive: "1",
      });

      const parsed = JSON.parse(res?.data?.data || "{}");
      const list = parsed?.Table || [];

      setPackages(list);
      setPackagesLoaded(true);

      if (selectAll) {
        const ids = list.map((p) =>
          String(
            p.WalletPackageID ?? p.PackageID ?? p.Id ?? p.PackageId ?? p.ID,
          ),
        );
        setSelectedPackages(ids);
      }
    } catch (err) {
      console.error("Error loading packages:", err);
      setPackages([]);
      setPackagesLoaded(false);
    }
  };

  const togglePackage = (id) => {
    const sid = String(id);
    setSelectedPackages((prev) =>
      prev.includes(sid) ? prev.filter((x) => x !== sid) : [...prev, sid],
    );
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h2 className="text-warning fw-bold">Coupon Codes</h2>
        <button className="btn btn-primary" onClick={() => setPostModal(true)}>
          Add Coupon Code
        </button>
      </div>

      <div className="col-12 mt-2">
        <DataTable
          dense
          data={data}
          columns={columns}
          selectableRowsHighlight
          highlightOnHover
          pagination
          fixedHeader
          customStyles={customStyles}
          persistTableHead
          noDataComponent={
            loading ? "Loading..." : "There are no data to display"
          }
        />
        {error && <div className="text-danger mt-2">{error}</div>}
      </div>

      <Modal
        show={postModal}
        onHide={() => setPostModal(false)}
        backdrop="static"
      >
        <form onSubmit={handleAddFormSubmit}>
          <div className="modal-header">
            <h4 className="modal-title fs-20">Add Coupon Code</h4>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setPostModal(false);
                resetForm();
              }}
            />
          </div>
          <div className="modal-body p-3">
            <div className="form-group">
              <label htmlFor="offercode-input" className="form-label">
                Offer Code <span className="text-danger">*</span>
              </label>
              <input
                id="offercode-input"
                type="text"
                className="form-control"
                autoComplete="off"
                value={addFormData.OfferCode}
                onChange={(e) =>
                  setAddFormData({ ...addFormData, OfferCode: e.target.value })
                }
                placeholder="Enter Offer Code"
                disabled={saving}
              />
            </div>

            <div className="form-group">
              <label htmlFor="offername-input" className="form-label">
                Offer Name
              </label>
              <input
                id="offername-input"
                type="text"
                className="form-control"
                autoComplete="off"
                value={addFormData.OfferName}
                onChange={(e) =>
                  setAddFormData({ ...addFormData, OfferName: e.target.value })
                }
                placeholder="Enter Offer Name"
                disabled={saving}
              />
            </div>

            <div className="form-group">
              <label htmlFor="discount-input" className="form-label">
                Bonus Amount
              </label>
              <input
                id="discount-input"
                type="number"
                className="form-control"
                autoComplete="off"
                value={addFormData.DiscountAmount}
                onChange={(e) =>
                  setAddFormData({
                    ...addFormData,
                    DiscountAmount: e.target.value,
                  })
                }
                placeholder="Enter Bonus Amount"
                disabled={saving}
              />
            </div>

            <div className="form-group">
              <label htmlFor="bonuspercentage-input" className="form-label">
                Bonus Type
              </label>
              <select
                id="bonuspercentage-input"
                className="form-select"
                value={addFormData.BonusPercentage}
                onChange={(e) =>
                  setAddFormData({
                    ...addFormData,
                    BonusPercentage: e.target.value,
                  })
                }
                disabled={saving}
              >
                <option value="">Select Bonus Type</option>
                <option value="Flat">Flat</option>
                <option value="Percent">Percentage</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Please select Package & Amount</label>

              <div className="d-flex gap-2 mb-2">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => loadPackages(true)}
                  disabled={saving}
                >
                  All
                </button>

                {/* <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => loadPackages(false)}
                  disabled={saving}
                >
                  Load
                </button>

                <small className="text-muted align-self-center">
                  (Select packages below or enter a value)
                </small> */}
              </div>

              {packages.map((p) => {
                const id = String(p.WalletPackageID);

                return (
                  <div
                    key={id}
                    className="d-flex align-items-center justify-content-between py-2 px-2 border-bottom"
                  >
                    <div className="d-flex align-items-center">
                      <input
                        type="checkbox"
                        checked={selectedPackages.includes(id)}
                        onChange={() => togglePackage(id)}
                        style={{
                          width: "18px",
                          height: "18px",
                          marginRight: "10px",
                          cursor: "pointer",
                          accentColor: "#0d6efd",
                          flexShrink: 0,
                        }}
                      />

                      <label
                        htmlFor={`pkg-${id}`}
                        className="mb-0"
                        style={{ cursor: "pointer", fontWeight: 500 }}
                      >
                        {p.PlanName}
                      </label>
                    </div>

                    <span className="fw-bold">₹{p.PackageAmt}</span>
                  </div>
                );
              })}

              {!packagesLoaded && (
                <input
                  id="minrecharge-input"
                  type="number"
                  className="form-control mt-2"
                  autoComplete="off"
                  value={addFormData.MinRechargeAmount}
                  onChange={(e) =>
                    setAddFormData({
                      ...addFormData,
                      MinRechargeAmount: e.target.value,
                    })
                  }
                  placeholder="Enter Package Amount or select packages above"
                  disabled={saving}
                />
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? "Saving..." : "Save"}
            </button>
            <button
              type="button"
              onClick={() => {
                setPostModal(false);
                resetForm();
              }}
              className="btn btn-danger"
            >
              Close
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default CouponCode;
